import React, {useState} from "react";
import LOGO from './../../assets/images/snapdc_logo.png'
import SideBarItem from "./SideBarItem";
import {useHistory} from "react-router-dom";
const nav = [
    {
        title : 'سفارش‌های امروز',
        path : '/panel/dashboard'
    },
    {
        title : 'گزارش سفارش‌ها',
        path : '/panel/order-report'
    },
    {
        title : 'گزارش مالی',
        path : '/panel/financial-report'
    },
]
const SideBar = (props) => {

    let history = useHistory();

    const [activeRoute,setActiveRoute] = useState(history.location.pathname)
    const isActive = (item) => {
        return activeRoute === item.path
    }
    const updateRoute = (item) => {
        setActiveRoute(item.path)
    }
    return (
        <>
            <div className="">
                <div className="logo-holder">
                    <img src={LOGO} alt="" width={110}/>
                </div>
                <div className="sidebar-nav">
                    {
                        nav.map((item, index) => {
                            return <SideBarItem key={index}  active={isActive(item)} title={item.title} onClick={() => updateRoute(item)} path={item.path}/>
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default SideBar;
